<script>
    import { fly } from 'svelte/transition';
    import { duplicateEngAlert } from '../../stores.js';
    import { Dispatcher } from '../../Dispatcher.js';
</script>

{#if $duplicateEngAlert}
    <div id="backdrop">
        <div id="alertWrapper" transition:fly="{{ y: 50, duration: 500 }}">
            <div id='alertMessage'>
                <span>Only a single Engineer per session!</span>
                <span class="detail">This room is already open as Engineer in another tab or on another computer. Using this tab disconnects the other one.</span>
            </div>
            <button class="take-over" on:click={() => Dispatcher.takeOverEng()}>Use this tab instead</button>
        </div>
    </div>
{/if}

<style>
    #backdrop {
        position: fixed;
        inset: 0;
        z-index: 9999;
        background: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(4px);
        -webkit-backdrop-filter: blur(4px);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #alertWrapper {
        z-index: 10000;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1.2em;
        max-width: min(32em, calc(100vw - 2em));
    }

    #alertMessage {
        display: flex;
        flex-direction: column;
        gap: 0.5em;
        font-family: "Helvetica", sans-serif;
        font-weight: 225;
        font-size: 17px;
        color: antiquewhite;
        background: #c62828cc;
        padding: 0.8em 1.2em;
        border-radius: 10px;
        box-shadow: 0px 4px 12px rgba(0,0,0,0.3);
        margin: 0;
    }

    #alertMessage .detail {
        font-size: 14px;
        line-height: 1.4;
        opacity: 0.9;
    }

    /* -- same look as the app's primary action (Join, and the reload overlay's button) */
    .take-over {
        font-family: inherit;
        font-size: 1.2rem;
        font-weight: 400;
        color: #ffd5d5;
        padding: 0.6em 1.4em;
        border: 0.05em solid rgba(255, 255, 255, 0.372);
        border-radius: 8px;
        background: #00a48a91;
        cursor: pointer;
        transition: background 0.18s ease;
    }

    .take-over:hover {
        background: #00887191;
    }
</style>
